<template>
  <div class="valuables">
    <div class="d-flex align-center mt-9" v-if="isShowTitle">
      <h4 class="font-20">Valuables</h4>
    </div>
    <div
      class="mb-3 mt-5 item__container"
      v-for="(valuable, index) in VALUABLES"
      :key="valuable.name"
    >
      <div class="d-flex flex-column flex-lg-row item__wrapper">
        <div class="col-lg-7 d-flex flex-row pa-0">
          <v-col
            v-if="valuable?.imageName"
            class="pl-0 py-0"
            :class="isDrawer ? 'pr-2' : 'pr-6'"
          >
            <img
              :src="
                require(`@/assets/images/customise-cover/${valuable?.imageName}`)
              "
              :alt="valuable?.imageName"
            />
          </v-col>
          <div class="d-flex flex-column">
            <p
              class="font-weight-bold main-title__wrapper d-flex align-center"
              v-if="valuable?.mainTitle"
            >
              {{ valuable?.mainTitle }}
              <v-icon
                v-if="
                  valuable?.modalData?.showLink &&
                  valuable?.modalData?.dialogComponentName &&
                  (isDrawer || ($vuetify.breakpoint.mobile && !isDrawer))
                "
                color="#106175"
                size="15"
                class="ml-2 text-cursor"
                @click="showModal(valuable.modalData.dialogComponentName)"
                >mdi-help-circle</v-icon
              >
            </p>
            <p class="ma-0 pr-6">
              {{ valuable.description }}
            </p>
            <span
              class="mt-5 d-flex align-center"
              v-if="
                valuable.modalData &&
                valuable.modalData.showLink &&
                valuable.modalData.ref
              "
            >
              <a
                class="align-self-start accent--text font-weight-bold link-popup"
                href="#"
                @click.prevent="$emit('showWhatsIncluded', valuable.modalData)"
              >
                {{ valuable?.textLinkToOpenPopup }}</a
              >
            </span>

            <span
              class="d-inline-flex align-center mt-5"
              v-if="
                valuable?.modalData?.showLink &&
                valuable?.modalData?.dialogComponentName &&
                !isDrawer &&
                !$vuetify.breakpoint.mobile
              "
            >
              <a
                class="align-self-start accent--text font-weight-semi-bold text-cursor"
                color="#106175"
                href="javascript:"
                @click="showModal(valuable.modalData.dialogComponentName)"
              >
                What's a valuable item?</a
              >
            </span>
          </div>
        </div>

        <div
          class="col-lg-5 pa-0 d-flex align-center mt-5 mt-lg-0 toggle-button__wrapper"
        >
          <BaseToggleButton
            v-model="valuable.form.isShow"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />
        </div>
      </div>
      <div v-if="valuable.form.isShow" class="form__wrapper">
        <div
          style="background-color: #354048"
          class="white--text d-flex justify-space-between font-16 mt-3 font-weight-bold"
        >
          <div
            class="col-12"
            :class="[
              valuable.form?.itemTypes?.length ? 'col-lg-8' : 'col-lg-7',
            ]"
          >
            {{ valuable.title }}
          </div>
          <div
            class="d-none d-lg-flex"
            :class="[
              valuable.form?.itemTypes?.length ? 'col-lg-4' : 'col-lg-5',
            ]"
          >
            {{ valuable.form.valueFieldLabel }}
          </div>
        </div>
        <ValidationObserver
          ref="form"
          v-slot="{ passes, reset, invalid, errors }"
        >
          <form
            @submit.prevent="
              (e) => OnSubmit(index, valuable, passes, reset, e.target)
            "
          >
            <div class="d-flex flex-column" style="background-color: #f3f3f3">
              <div
                class="d-flex flex-column flex-lg-row flex-wrap mb-3 mb-lg-0"
              >
                <BaseSelect
                  name="itemType"
                  hideDetails
                  :rules="{
                    required: {
                      required: true,
                      fieldLabel: 'Item type',
                    },
                  }"
                  v-if="valuable.form?.itemTypes?.length"
                  class="col-lg-8 pa-lg-3 select__wrapper"
                  :items="valuable.form.itemTypes"
                  :label="!$vuetify.breakpoint.lgAndUp ? 'Item type' : ''"
                  v-model="valuable.form.selectedItemType"
                  :dense="$vuetify.breakpoint.lgAndUp"
                />
                <BaseInput
                  name="itemDescription"
                  :rules="{
                    required: {
                      required: true,
                      fieldLabel: 'Description',
                    },
                  }"
                  hideDetails
                  class="pa-lg-3"
                  :placeholder="
                    $vuetify.breakpoint.lgAndUp
                      ? 'Please provide a brief description of the item...'
                      : ''
                  "
                  :label="
                    !$vuetify.breakpoint.lgAndUp
                      ? valuable.form.descriptionFieldLabel
                      : ''
                  "
                  v-model="valuable.form.descriptionFieldValue"
                  :class="[
                    valuable.form?.itemTypes?.length
                      ? 'order-lg-2 flex-grow-1 col-lg-10'
                      : 'flex-grow-1 col-lg-7',
                  ]"
                  :dense="$vuetify.breakpoint.lgAndUp"
                />
                <BaseInput
                  name="itemValue"
                  :rules="{
                    required: {
                      required: true,
                      fieldLabel: 'Item value',
                    },
                    regex: {
                      required: true,
                      fieldLabel: 'Item value',
                      pattern: REGEXP_PP_ITEM_VALUE,
                      customMessage:
                        'Value format is invalid - please enter whole pounds only.',
                    },
                    min_currency_value: {
                      minValue: valuable.form.valueFieldMinValue,
                      fieldLabel: 'Item value',
                    },
                  }"
                  hideDetails
                  :label="
                    !$vuetify.breakpoint.lgAndUp
                      ? valuable.form.valueFieldLabel
                      : ''
                  "
                  class="pa-lg-3"
                  :class="[
                    valuable.form?.itemTypes?.length
                      ? ' col-lg-4 col-7'
                      : 'col-lg-3 col-7',
                  ]"
                  minWidth="200"
                  :dense="$vuetify.breakpoint.lgAndUp"
                  prefix="£"
                  v-model="valuable.form.valueFieldValue"
                  validationMode="lazy"
                  moneyFormat
                />
                <div
                  class="d-flex justify-end order-lg-4 col-lg-2 pa-lg-3 align-end"
                >
                  <BaseButton
                    depressed
                    name="add"
                    text="ADD"
                    rounded
                    :height="$vuetify.breakpoint.lgAndUp ? '40' : '60'"
                    block
                    dense
                    :color="'psorange'"
                    class="font-weight-bold font-18"
                    type="submit"
                  />
                </div>
              </div>

              <template v-for="(error, index) in errors">
                <v-alert
                  :key="index"
                  dense
                  text
                  type="error"
                  icon="mdi-alert-circle"
                  class="mr-3 mb-3 ml-3"
                  outlined
                  v-if="error.length"
                >
                  <span class="black--text">
                    {{ error[0] }}
                  </span>
                </v-alert>
              </template>
            </div>
          </form>
        </ValidationObserver>
        <template v-if="valuable.items.length">
          <div
            class="valuable-container"
            v-for="(item, index) in valuable.items"
            :key="index"
          >
            <div class="border-r10 pa-3 mt-5">
              <div class="d-flex justify-space-between">
                <div class="flex-grow-1">
                  <div class="item-title font-14 pa-1 px-4">
                    {{ valuable.itemsTitle ? valuable.itemsTitle : item.text }}
                  </div>
                </div>
                <div class="d-none d-lg-flex">
                  <BaseButton
                    text="REMOVE"
                    flat
                    rounded
                    small
                    icon="mdi-minus-circle"
                    class="font-16"
                    @click="valuable.items.splice(index, 1)"
                    :iconColor="'var(--red-500)'"
                    :link="true"
                  />
                </div>
              </div>
              <div
                class="d-flex pa-4 justify-space-between font-weight-bold font-20 description__wrapper"
              >
                <h4 class="mr-6">{{ item.description }}</h4>
                <h4>
                  {{ item.value | formatCurrency(AMOUNT_INSURED_FORMAT) }}
                </h4>
              </div>
            </div>
            <div class="justify-center d-flex d-lg-none">
              <BaseButton
                text="REMOVE"
                flat
                rounded
                small
                icon="mdi-minus-circle"
                class="font-16 mt-5"
                @click="valuable.items.splice(index, 1)"
                :iconColor="'var(--red-500)'"
                :link="true"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseSelect from "@/components/BaseComponents/BaseSelect.vue";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton.vue";
import { AMOUNT_INSURED_FORMAT } from "@/constants/currency-format.constants";
import { REGEXP_PP_ITEM_VALUE } from "@/constants/regex-patterns.constants";
import { DIALOG_MODULE, QUESTIONS_MODULE } from "@/store/types/module-types";
import { ValidationObserver } from "vee-validate";
import { mapGetters, mapMutations } from "vuex";
export default {
  components: {
    BaseButton,
    BaseToggleButton,
    BaseInput,
    ValidationObserver,
    BaseSelect,
  },
  props: {
    cover: Object,
    VALUABLES: {
      type: Array,
      required: true,
    },
    isShowTitle: {
      type: Boolean,
      default: true,
      required: false,
    },
    isSelfserve: {
      type: Boolean,
      default: false,
      required: false,
    },
    isDrawer: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      AMOUNT_INSURED_FORMAT,
      REGEXP_PP_ITEM_VALUE,
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["getQuestionCoverType"]),
    isValuablesOverLimit() {
      let valuablesTotalWorth = 0;
      let isValuablesOverLimit;

      this.VALUABLES.forEach((valuable) => {
        if (!valuable.form.isShow) return;
        valuable.items.forEach((item) => {
          valuablesTotalWorth += parseFloat(item.value);
        });
      });

      isValuablesOverLimit =
        valuablesTotalWorth > (this.cover.contentsCover.amount / 100) * 30; // 30 percent of whatever contents cover is selected

      return isValuablesOverLimit;
    },
  },
  watch: {
    isValuablesOverLimit() {
      this.$emit("isValuablesOverLimitUpdate", this.isValuablesOverLimit);
    },
  },
  methods: {
    ...mapMutations(DIALOG_MODULE, ["showModal"]),
    OnSubmit(index, possession, passes, resetForm, nativeForm) {
      passes(() => {
        this.VALUABLES[index].items.push({
          description: possession.form.descriptionFieldValue,
          value: this.removeComma(possession.form.valueFieldValue),
          itemType: possession.form.selectedItemType,
          text: possession.form.itemTypes.find(
            (itemType) => itemType.value === possession.form.selectedItemType
          )?.text,
        });

        this.VALUABLES[index].form.descriptionFieldValue = null;
        this.VALUABLES[index].form.valueFieldValue = null;
        this.VALUABLES[index].form.selectedItemType = null;

        this.$nextTick(() => {
          resetForm();
        });

        nativeForm
          ?.querySelectorAll(".money-format input")
          .forEach((input) => (input.value = ""));
      });
    },
    removeComma(value) {
      return value ? value.replaceAll(",", "") : value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/AppComponents/_DrawerCustomizeCover.scss";
</style>
